var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"extra-wrapper"},[_c('div',{staticClass:"title",attrs:{"ar":_vm.$i18n.locale === 'ar'}},[_c('h1',[_vm._v(_vm._s(_vm.label))]),_c('p',[_vm._v(_vm._s(_vm.extra))])]),_c('div',{staticClass:"content"},[(_vm.child === 'cards')?_c('Cards',_vm._g(_vm._b({},'Cards',_vm.$attrs,false),_vm.$listeners)):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }